// src/components/analytics/analytics-provider.tsx
"use client";

import React, { useEffect } from 'react';
import { usePathname, useSearchParams } from 'next/navigation';

// Placeholder for analytics service integration (e.g., Google Analytics, Plausible, etc.)
// In a real app, you would initialize your analytics service here.

const logPageView = (path: string) => {
  // Example: window.gtag('event', 'page_view', { page_path: path });
  // Example: window.plausible('pageview');
  console.log(`Analytics: Page view tracked for ${path}`);
};

export function AnalyticsProvider({ children }: { children: React.ReactNode }) {
  const pathname = usePathname();
  const searchParams = useSearchParams();

  useEffect(() => {
    // Track page views when path or search params change
    const url = `${pathname}${searchParams.toString() ? `?${searchParams.toString()}` : ''}`;
    logPageView(url);
  }, [pathname, searchParams]);

  return <>{children}</>;
}
